import React from "react";
import { Route, Switch } from "react-router";
import { RestrictedRoute } from "../utils/RestrictedRoute";
import { Permissions } from "../utils/Permissions";
import MessageTemplatesTable from "../components/WorkshopPlanning/General/MessageTemplates/MessageTemplatesTable";
import MessageTemplatesCreation from "../components/WorkshopPlanning/General/MessageTemplates/MessageTemplatesCreation";

export default function MessageTemplatesRouting(props) {
	const { currentIdentity, resources } = props;

	return (
		<>
			<RestrictedRoute
				path="/messagetemplates"
				userPermissions={currentIdentity.permissions}
				routePermissions={[Permissions.WorkshopSettings]}
				resources={resources}
				render={(props) => {
					return (
						<MessageTemplatesTable
							userPermissions={currentIdentity.permissions}
							resources={resources}
							accessibleMoboOutlets={currentIdentity.accessibleMoboOutlets}
							outletId={props?.location?.state?.outletId}
							refreshGrid={props?.location?.state?.refreshGrid}
							objectType={currentIdentity.objectType}
						/>
					);
				}}
			/>

			<Switch>
				<Route
					exact
					path="/messagetemplates/new"
					render={() => (
						<MessageTemplatesCreation
							resources={resources}
							defaultObjectType={currentIdentity.objectType}
							language={currentIdentity.culture.slice(0, 2)}
							accessibleMoboOutlets={currentIdentity.accessibleMoboOutlets}
							dealerGroupId={currentIdentity.moboDealerGroupId}
						/>
					)}
				/>
				<Route
					path="/messagetemplates/:templateId"
					render={() => (
						<MessageTemplatesCreation
							resources={resources}
							defaultObjectType={currentIdentity.objectType}
							language={currentIdentity.culture.slice(0, 2)}
							accessibleMoboOutlets={currentIdentity.accessibleMoboOutlets}
							dealerGroupId={currentIdentity.moboDealerGroupId}
						/>
					)}
				/>
			</Switch>
		</>
	);
}
